module.exports = __webpack_public_path__ + "img/points-badge.2299e6ab.svg";